import request from 'tools/request'
import {RoleListResponse, RoleResponse} from 'types/rolePermission'

export const listRoles = async () => {
  return await request.get<RoleListResponse>('roles').then((res) => res.data)
}

export const loadPermissions = async () => {
  return await request.get<RoleResponse>(`roles/me`).then((res) => res.data)
}
